module.exports = __webpack_public_path__ + "img/kumo_5.82d8f90c.svg";